/* @flow */

import { isNil } from 'lodash/fp';

export function noOrphanWords(str: string) {
  return str.replace(/\s([^\s<]+)\s*$/, '\u00a0$1');
}

export function largestMatchingString(list: Array<string> = []) {
  if (list.length === 0 || list.some(isNil)) {
    return undefined;
  }

  if (list.length === 1) {
    return list[0];
  }

  const findLargestMatchingString = (littleString: string, bigString: string) => {
    if (littleString === bigString) {
      return littleString;
    }

    const testString = bigString.slice(0, Math.ceil((littleString.length + bigString.length) / 2));

    if (list.every(str => str.startsWith(testString))) {
      return findLargestMatchingString(testString, bigString);
    }

    return findLargestMatchingString(littleString, testString.slice(0, -1));
  };

  return findLargestMatchingString('', list[0]);
}

export function joinUntilFalsy(array: Array<?string>, separator: string = ',') {
  const index = array.findIndex(x => !x);
  if (index === -1) return array.join(separator);
  return array.slice(0, index).join(separator);
}
